var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container vh-100"},[_c('div',{staticClass:"row h-75 justify-content-center align-items-center"},[_c('div',{staticClass:"col col-xl-4"},[_c('login-form',{attrs:{"requesting":_vm.requesting,"errMsg":_vm.errMsg},on:{"login":_vm.onLogin}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }